import React, { useState } from "react";
import { Col, Row, Card, CardBody, Modal, ModalBody } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ResaleService from "services/Website/ResaleService";
import PropertyService from "services/Website/PropertyService";
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import CompoundService from "services/Website/CompoundService";

const MessageModal = ({ modal, setModal, item, type }) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state?.Auth);
	const lang = useSelector((state) => state?.Auth?.lang) || "en";
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");
	const currency = useSelector((state) => state.Auth?.currency);
	const propertyService = new PropertyService();
	const compoundService = new CompoundService();

	const handleValidSubmit = (e, v) => {
		setLoading(true);
		if (type === "compound") {
			const data = {
				comment: v.message,
				compound_id: item.id,
				attattachment:
					item?.images?.length > 0 ? item.images.map((img) => img.path) : [],
			};
			compoundService.sendCil(data).then((res) => {
				if (res && res.status === SuccessOk) {
					toast.success("Message Sent successfully");
					setModal(false);
				}
				setLoading(false);
			});
		} else {
			const data = {
				comment: v.message,
				unit_id: item.id,
				attattachment:
					item?.images?.length > 0 ? item.images.map((img) => img.path) : [],
			};
			propertyService.sendCil(data).then((res) => {
				if (res && res.status === SuccessOk) {
					toast.success("Message Sent successfully");
					setModal(false);
				}
				setLoading(false);
			});
		}
	};

	return (
		<Modal
			isOpen={modal}
			toggle={() => setModal(false)}
			style={{
				maxWidth: "600px",
				marginTop: "10%",
				width: "100%",
			}}
			className={`message-modal ${lang !== "ar" ? "" : "ar-wrapper"}`}>
			<ModalBody className="m-0 p-0 fw-bold">
				<div
					className="overflow-hidden m-0 p-0"
					style={{ direction: "inherit" }}>
					<div className=" p-0 m-0">
						<p
							style={{ fontSize: "32px" }}
							className="mb-1 text-center bask-font text-primary">
							{t("Send us a Message")}
						</p>
						<p className="text-primary subtitle text-center m-auto fw-300">
							{t(
								"WE'RE HERE TO HELP WITH ANY QUESTIONS OR INQUIRIES YOU MAY HAVE"
							)}
						</p>
						{type == "unit" && (
							<Row className="mx-4">
								<Col md={4} className="my-2 ">
									<Row className="font-size-14 text-primary">
										{t("Unit Code")}
									</Row>
									<Row className="fw-bold text-primary">
										{item?.name[lang] ? item?.name[lang] : item?.name.en}
									</Row>
								</Col>
								<Col md={4} className="my-2 ">
									<Row className="font-size-14 text-primary">
										{t("location")}
									</Row>
									<Row className="fw-bold text-primary">
										{item?.address[lang]
											? item?.address[lang]
											: item?.address?.en}
									</Row>
								</Col>
								<Col md={4} className="my-2 ">
									<Row className="font-size-14 text-primary">{t("beds")}</Row>
									<Row className="fw-bold text-primary">{item?.bedrooms}</Row>
								</Col>
								<Col md={4} className="my-2 ">
									<Row className="font-size-14 text-primary">{t("Size")}</Row>
									<Row className="fw-bold text-primary">
										{parseInt(item?.size).toFixed(0)} {t("sqm")}
									</Row>
								</Col>
								<Col md={4} className="my-2 ">
									<Row className="font-size-14 text-primary">{t("price")}</Row>
									<Row className="fw-bold text-primary">
										{toCurrency(item?.price)} {currency?.currency_code}
									</Row>
								</Col>
								<Col md={4} className="my-2 ">
									<Row className="font-size-14 text-primary">
										{t("Unit Type")}
									</Row>
									<Row className="fw-bold text-primary">
										{" "}
										{item?.unit_type?.name[lang]
											? item?.unit_type?.name[lang]
											: item?.unit_type?.name?.en}
									</Row>
								</Col>
							</Row>
						)}
						<Row className="my-4 mx-2 fw-bold">
							<AvForm
								className="form-horizontal"
								onValidSubmit={(e, v) => {
									handleValidSubmit(e, v);
								}}>
								<label className="text-primary fw-bold font-size-16">
									Message
								</label>
								<AvField
									name="message"
									placeholder="Type Message"
									className="form-control"
									type="textarea"
									bsSize="lg"
								/>

								<div className="text-center mt-4">
									<button
										className="btn btn-success btnHeight"
										disabled={loading}>
										{t("Send Message")}
									</button>
								</div>
							</AvForm>
						</Row>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default MessageModal;
